import React from "react";
import styled from "styled-components";
import { ExpressionValue } from "../../rule-engine-core/Expressions/ExpressionValue";
import { ExpressionRuleRegistrationData } from "../../rule-engine-core/Expressions/RegisterExpressionRule";
import { GetExpressionRuleIcon } from "./RegisterExpressionRuleEditor";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export const AddExpressionButton = function (props: {
    registration: ExpressionRuleRegistrationData;
    expression: ExpressionValue;
    onClick: (registration: ExpressionRuleRegistrationData) => void;
    hideLabel: boolean;
    showCategory?: boolean;
}) {
    return (
        <ToolboxItem
            hideLabel={props.hideLabel}
            onClick={() => {
                props.onClick(props.registration);
            }}
            data-testid={`expression-${props.registration.name}`}
        >
            <ToolboxItemIcon>{GetExpressionRuleIcon(props.registration.type)}</ToolboxItemIcon>
            {!props.hideLabel && props.showCategory && (
                <ToolboxItemText>{props.registration.name + " [" + props.registration.category + "]"}</ToolboxItemText>
            )}
            {!props.hideLabel && !props.showCategory && <ToolboxItemText>{props.registration.name}</ToolboxItemText>}
        </ToolboxItem>
    );
};

const ToolboxItem = styled("div")<{ hideLabel: boolean }>`
    display: flex;
    flex-direction: row;

    float: left;
    box-sizing: border-box;
    border-radius: 4px;
    height: 32px;

    color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};

    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 15px;
    letter-spacing: 0em;
    text-align: left;

    align-items: center;
    cursor: pointer;
`;

const ToolboxItemIcon = styled.div`
    display: flex;
    border: 1px solid ${UIStyleConstants.GRAY_LIGHTER_COLOR};
    width: 38px;
    height: 32px;
    box-sizing: border-box;
    border-radius: 4px;
    align-items: center;
    justify-content: center;
`;

const ToolboxItemText = styled.div`
    display: flex;
    float: left;
    margin-left: 8px;
    //styleName: text/Inter Regular 11px;

    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 15px;
    letter-spacing: 0em;
    text-align: left;

    color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};

    flex: 1;
`;
